import { IPhoneSchema } from '../../../repositories/newbuilding-card/entities/builder/PhoneSchema';
import { isCorrectPhoneObject } from './isCorrectPhoneObject';

export function phoneToString(phone?: IPhoneSchema | null) {
  if (phone && isCorrectPhoneObject(phone)) {
    return `${phone.countryCode}${phone.code}${phone.number}`;
  }

  return '';
}
